module.exports = __webpack_public_path__ + "img/ic-loading-primary.4879b029.svg";